const CookieInfo = () => {
  return (
    <div className="max-width">
      <h3>Cookie Policy</h3>
      <ol>
        <li>
          <strong>What Are Cookies: </strong>
          We use “cookies” and similar technologies (such as web beacons,
          pixels, and local storage) to collect information when you visit our
          website. A cookie is a small text file stored on your device that
          allows us to recognize your device and retain certain information.
        </li>
        <li>
          <strong>Why We Use Cookies: </strong> We use cookies for several
          purposes, including: Remembering your settings and preferences to make
          our website easier to use. Improving our website and analyzing how
          visitors use it—for example, which pages you visit and how long you
          stay. Enabling essential functions such as authentication or session
          management. (If applicable) Delivering targeted advertising or sharing
          anonymized usage data with third-party providers.
        </li>
        <li>
          <strong>Types of Cookies We Use: </strong> Session cookies – These are
          deleted when you close your browser. Persistent cookies – These remain
          on your device for a set period of time or until you delete them
          manually. Third-party cookies – Some cookies are placed by external
          providers (such as analytics or advertising networks) through our
          website.
        </li>
        <li>
          <strong>Your Choices and Rights: </strong> You have the right to
          control or restrict the use of cookies: You can adjust your browser
          settings to block cookies or to alert you before a cookie is stored.
          Please note that blocking or deleting cookies may affect the
          functionality of our site. If you do not wish to accept certain types
          of cookies (for example, analytics or advertising cookies), you can
          disable them or decline consent where such options are available.
        </li>
        <li>
          <strong>Massachusetts-Specific Requirements: </strong> We strive to
          comply with the privacy and data protection guidelines applicable to
          residents of Massachusetts. While Massachusetts does not yet have a
          comprehensive cookie law, various privacy and data protection laws
          regulate the handling of personal information and tracking
          technologies. As such, we commit to: Providing clear information about
          the types of cookies we use and their purposes. Seeking your consent
          where cookies collect personally identifiable information or are used
          for targeted advertising. Allowing you to exercise your rights to
          access, correct, or delete your personal information where applicable.
        </li>
        <li>
          {" "}
          <strong>Children and Cookies: </strong>
          Our website is not directed toward children under the age of 13. We
          take additional precautions when handling data that may relate to
          minors. If you are a parent or guardian and believe that your child
          has provided us with personal information, please contact us using the
          details below.
        </li>
        <li>
          <strong>Changes to This Policy: </strong> We may update this Cookie
          Policy from time to time—for example, when our use of cookies changes
          or when new laws come into effect. The latest version of this policy
          will always be available on our website.
        </li>
        <li>
          <strong>Contact: </strong> If you have any questions or would like to
          exercise your rights regarding cookies or personal data, please email
          us at info@rozwon.com
        </li>
      </ol>
    </div>
  );
};

export default CookieInfo;
